import React from 'react'
import { useLocation } from 'react-router-dom'

function ServicesIcon({ size = 28 }) {
    const location = useLocation()
    const isActive = location.pathname.startsWith('/services')
    const color = isActive ? '#FFFFFF' : '#8F9DAC'

    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 28 28"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M12.8333 6.41675H24.5"
                stroke={color}
                strokeWidth="1.8"
                strokeLinecap="round"
            />
            <path
                d="M6.3 19.7081C7.54445 20.5416 8.16667 20.9583 8.16667 21.5834C8.16667 22.2085 7.54445 22.6253 6.3 23.4587C5.05555 24.2922 4.43333 24.7088 3.96667 24.3964C3.5 24.0838 3.5 23.2504 3.5 21.5834C3.5 19.9165 3.5 19.083 3.96667 18.7705C4.43333 18.458 5.05555 18.8747 6.3 19.7081Z"
                stroke={color}
                strokeWidth="1.8"
                strokeLinecap="round"
            />
            <path
                d="M6.3 4.5414C7.54445 5.37485 8.16667 5.79158 8.16667 6.41666C8.16667 7.04175 7.54445 7.45847 6.3 8.29193C5.05555 9.12538 4.43333 9.54211 3.96667 9.22956C3.5 8.91702 3.5 8.08356 3.5 6.41666C3.5 4.74977 3.5 3.91631 3.96667 3.60377C4.43333 3.29122 5.05555 3.70795 6.3 4.5414Z"
                stroke={color}
                strokeWidth="1.8"
                strokeLinecap="round"
            />
            <path
                d="M12.8333 14H24.5"
                stroke={color}
                strokeWidth="1.8"
                strokeLinecap="round"
            />
            <path
                d="M12.8333 21.5833H24.5"
                stroke={color}
                strokeWidth="1.8"
                strokeLinecap="round"
            />
        </svg>
    )
}

export default ServicesIcon
